import AlarmDetail from './Detail';
import DeviationAlarm from './index';

const routes = [
  {
    path: '/dispatch/control/deviation-alarm',
    element: <DeviationAlarm />,
  },
  {
    path: '/dispatch/control/deviation-alarm/:id/view',
    element: <AlarmDetail />,
  },
];

export default routes;
